import React from 'react';
import PropTypes from 'prop-types';

import PopupNg from '@/ui/PopupNg';
import i18n from '@i18n';

import Dialog, { DialogActions, DialogBody, DialogButton, DialogTitle } from './Dialog';

function MessageDialog({
    titleIcon,
    titleText,
    bodyText,
    className,
    cancelText,
    confirmText = i18n('jsp.message.zavriet'),
    modal,
    onCancel,
    onConfirm,
    onClose,
    ...rest
}) {
    const close = PopupNg.dispatcher.close;
    function onCancelClick() {
        close();
        onCancel && onCancel();
    }
    function onConfirmClick() {
        close();
        onConfirm && onConfirm();
    }
    return (
        <Dialog className={className} modal={modal} onClose={onClose} {...rest}>
            {titleText || titleIcon ? (
                <DialogTitle className={className}>
                    {titleIcon ? <div className={`dialog-title-icon ${titleIcon}`} /> : null}
                    {titleText ? <h2>{i18n(titleText)}</h2> : null}
                </DialogTitle>
            ) : null}
            {bodyText ? (
                <DialogBody>
                    <p>{i18n(bodyText)}</p>
                </DialogBody>
            ) : null}
            <DialogActions>
                {cancelText ? (
                    <DialogButton className="light" onClick={onCancelClick}>
                        {i18n(cancelText)}
                    </DialogButton>
                ) : null}
                <DialogButton onClick={onConfirmClick}>{i18n(confirmText)}</DialogButton>
            </DialogActions>
        </Dialog>
    );
}

MessageDialog.propTypes = {
    titleIcon: PropTypes.string,
    titleText: PropTypes.string,
    bodyText: PropTypes.string,
    className: PropTypes.string,
    cancelText: PropTypes.string,
    confirmText: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    onClose: PropTypes.func
};

export default MessageDialog;
